var map = {
	"./s_t_1.png": "CKM6",
	"./s_t_2.png": "LP2f",
	"./s_t_3.png": "YExu",
	"./s_t_4.png": "nluS",
	"./s_t_5.png": "kyME",
	"./s_t_6.png": "Oz91",
	"./s_t_7.png": "93JY",
	"./s_t_8.png": "+RRA",
	"./s_t_9.png": "7H42"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9zmS";


//////////////////
// WEBPACK FOOTER
// ./packages/appletView/src/static/img/icons ^\.\/s_t_.*\.png$
// module id = 9zmS
// module chunks = 1